module.exports = __webpack_public_path__ + "img/icons8-open-box-50.ef805d37.png";